module.exports = __webpack_public_path__ + "img/IMG-20200317-WA0006.de053e07.jpg";